import React from 'react'
import { Icon, Tooltip, Text } from '@components/UI'

const Path = ({ line, onClick, dark, tooltip = {} }) => {
  return (
    <div className={`control-container ${dark ? 'dark' : ''}`}>
      <button>
        <Icon name='line-props' />
      </button>
      <Tooltip
        content={
          <div className='tooltip-content'>
            <div>
              <Text
                className='text-c semibold'
                style={{ lineHeight: 1, opacity: 0.5 }}
              >
                Line Style
              </Text>
              <div style={{ display: 'flex', marginTop: 8 }}>
                <div
                  className='control-container'
                  style={{ height: 'auto', justifyContent: 'flex-start' }}
                >
                  <Icon
                    name='line'
                    className={`tooltip-icon ${
                      line.style === 'normal' ? 'active' : ''
                    }`}
                    events={{
                      onClick: () => onClick({ style: 'normal' })
                    }}
                  />
                </div>
                <div
                  className='control-container'
                  style={{ height: 'auto', justifyContent: 'flex-start' }}
                >
                  <Icon
                    name='line dashed'
                    className={`tooltip-icon ${
                      line.style === 'dashed' ? 'active' : ''
                    }`}
                    events={{
                      onClick: () => onClick({ style: 'dashed' })
                    }}
                  />
                </div>
              </div>
            </div>
            <div style={{ marginTop: 16 }}>
              <Text
                className='text-c semibold'
                style={{ lineHeight: 1, opacity: 0.5 }}
              >
                Line Width
              </Text>
              <div style={{ display: 'flex', marginTop: 8 }}>
                <div
                  className='control-container'
                  style={{ height: 'auto', justifyContent: 'flex-start' }}
                >
                  <Icon
                    name='line'
                    className={`tooltip-icon ${
                      line.width === 1 ? 'active' : ''
                    }`}
                    events={{
                      onClick: () => onClick({ width: 1 })
                    }}
                  />
                </div>
                <div
                  className='control-container'
                  style={{ height: 'auto', justifyContent: 'flex-start' }}
                >
                  <Icon
                    name='line-2x'
                    className={`tooltip-icon ${
                      line.width === 2 ? 'active' : ''
                    }`}
                    events={{
                      onClick: () => onClick({ width: 2 })
                    }}
                  />
                </div>
                <div
                  className='control-container'
                  style={{ height: 'auto', justifyContent: 'flex-start' }}
                >
                  <Icon
                    name='line-3x'
                    className={`tooltip-icon ${
                      line.width === 3 ? 'active' : ''
                    }`}
                    events={{
                      onClick: () => onClick({ width: 3 })
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        }
        group={tooltip.top ? 'c2' : 'c7'}
        className='theme color-f background-a border'
      />
      <Icon name='arrow down' />
    </div>
  )
}

export default Path
